// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"41":"error","328":"admin","620":"collections","767":"details"}[chunkId] + "." + {"41":"1fa3b561","328":"9136ae04","620":"e2f93b2d","767":"2014c463"}[chunkId] + ".css";
};